import { AppConfiguration } from "config";
import React, { useEffect, useState } from 'react';
import Breadcrumbs from 'components/Common/Breadcrumb';
import MetaTags from 'react-meta-tags';
import {
  Col, Container, Row,
  TabPane, TabContent, CardBody, Card
} from "reactstrap";
import LeadSnapshot from "components/Common/LeadDetail/LeadSnapshot";
import {
  useLocation, useParams,
} from 'react-router-dom';
import LeadDrivers from "components/Common/LeadDetail/LeadDrivers";
import LeadVehicles from "components/Common/LeadDetail/LeadVehicles";
import LeadCoverage from "components/Common/LeadDetail/LeadCoverage";
import LeadViolations from "components/Common/LeadDetail/LeadViolations";
import { useDispatch, useSelector } from "react-redux";
import LeadHomes from "components/Common/LeadDetail/LeadHome";
import LeadBusinessEntity from "components/Common/LeadDetail/LeadBusinessEntity";
import LeadBusinessEntityGroupHealth from "components/Common/LeadDetail/LeadBusinessEntityGroupHealth";
import { getLeadById, getLeadDetailReport } from "store/leads/actions";
import LeadDetailLoading from "components/Common/Loadings/LeadSnapshotLoading";
import LeadSubSectionLoading from "components/Common/Loadings/LeadSubSectionLoading";
import LeadNavLinkLoading from "components/Common/Loadings/LeadNavLinkLoading";
import LeadClaims from "components/Common/LeadDetail/LeadClaims";
import CallTranscription from "pages/CallsTranscription/CallTranscription";
import CallDetailBreadcrumb from "./CallDetailBreadcrumb";
import SfNavLink from "components/Common/SfNavLink";
import CallSummary from "./call-summary/CallSummary";
import useFeatureFlags from 'hooks/useFeatureFlags';
import { REQUIRED_FEATURE_FLAGS, LEAD_TYPE_IDS, BUSINESS_LEAD_TYPES } from "helpers/sf_constants";
import { CSVExport } from "react-bootstrap-table2-toolkit";
import { isAutoOrMotorcycle } from "helpers/sf_leads_calls_helper";
import { getLeadRefundReasons } from "store/leads/lead_refund_reasons_actions";
import useSingleActionDispatcher from "hooks/useSingleActionDispatcher";
import { isBenepathBrand } from "config";
import { getLeadNotesSuccess, createLeadNotes, getLeadNotes, getCallNotesSuccess, createCallNotes } from "store/notes/lead_notes/actions";
import { extractNotesFromLeadsOrCalls, extractCallNotesFromCalls, openNotesModal } from "helpers/sf_lead_notes_helper";
import LeadNoteModal from "components/Common/Notes/LeadNoteModal";

const LeadDetail = (props) => {

  const [isFeatureFlagActive] = useFeatureFlags();

  const dispatch = useDispatch()
  const { ExportCSVButton } = CSVExport;
  //Create a state for lead_type
  const location = useLocation();
  // Determine if this is a call details page (must be declared early)
  const isCallDetailsPage = location.pathname.startsWith('/calls/');

  const [lead_data, setLeadData] = useState({})
  const [showTranscription, setShowTranscription] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [leadNoteModal, setLeadNoteModal] = useState({
    action: false,
    lead_id: null,
    notes: [],
  });
  const { lead_id } = useParams();
  const {
    leads,
    loading,
    current_account,
    lead_refund_reasons,
    loading_lead_detail_export,
    lead_notes,
    call_notes,
    update_lead_notes_success,
    update_call_notes_success
  } = useSelector(state => ({
    leads: state.Leads.leads,
    loading: state.Leads.loading,
    current_account: state.accounts.current_account,
    lead_refund_reasons: state.Leads.lead_refund_reasons,
    loading_lead_detail_export: state.Leads.loading_lead_detail_export,
    lead_notes: state.leadNotesReducer.lead_notes,
    call_notes: state.leadNotesReducer.call_notes,
    update_lead_notes_success: state.leadNotesReducer.update_lead_notes_success,
    update_call_notes_success: state.leadNotesReducer.update_call_notes_success,
  }));

  useSingleActionDispatcher(getLeadRefundReasons());

  useEffect(() => {
    if (update_lead_notes_success && lead_id && !isCallDetailsPage) {
      dispatch(getLeadNotes({ lead_id: lead_id }));
    }
  }, [update_lead_notes_success, lead_id, dispatch, isCallDetailsPage]);

  // Note: After creating/updating/deleting call notes, we refresh the lead data which includes updated call_notes
  useEffect(() => {
    if (update_call_notes_success && lead_id && isCallDetailsPage) {
      // Refresh lead data to get updated call_notes from the API
      dispatch(getLeadById({ id: lead_id }));
    }
  }, [update_call_notes_success, lead_id, dispatch, isCallDetailsPage]);

  //Create a useEffect and get lead data from redux store from lead_id from useParams
  useEffect(() => {
    if (leads.length > 0 && lead_id) {
      const lead = leads.find(lead => lead.id === parseInt(lead_id));
      if (lead) {
        setLeadData(lead);
      }
    }

  }, [leads, lead_id])

  useEffect(() => {
    if (lead_id) {
      dispatch(getLeadById({ id: lead_id }))
    }
  }, [lead_id, dispatch])

  // Note: We don't fetch call notes separately - they come with the lead data in quote_call.call_notes

  // Extract notes from lead_data when it's updated from getLeadById API response (Benepath only)
  useEffect(() => {
    if (!(isBenepathBrand && lead_data)) return;
    
    // For call details pages, extract call_notes from quote_call.call_notes
    if (isCallDetailsPage && lead_data.quote_call?.call_notes) {
      // Create a call object structure for extraction using quote_call data
      const callObject = {
        id: lead_data.quote_call.id, // Use quote_call.id as the call_id
        call_notes: lead_data.quote_call.call_notes
      };
      const extractedNotes = extractCallNotesFromCalls([callObject]);
      if (extractedNotes.notes.length > 0 || extractedNotes.processedCallIds.length > 0) {
        dispatch(getCallNotesSuccess(extractedNotes));
      }
    }
    // For lead details pages, extract lead_notes
    else if (!isCallDetailsPage && lead_data.lead_notes) {
      const extractedNotes = extractNotesFromLeadsOrCalls([lead_data]);
      if (extractedNotes.notes.length > 0 || extractedNotes.processedLeadIds.length > 0) {
        dispatch(getLeadNotesSuccess(extractedNotes));
      }
    }
  }, [lead_data, dispatch, isBenepathBrand, isCallDetailsPage])

  const [customActiveTab, setcustomActiveTab] = useState('1');

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  useEffect(() => {
    if (location) {
      if (lead_data?.lead_type_id === LEAD_TYPE_IDS.HOME) {
        if (location.hash.includes('applicants')) {
          setcustomActiveTab('1');
        }
        if (location.hash.includes('homes')) {
          setcustomActiveTab('2');
        }
        if (location.hash.includes('existing-coverage')) {
          setcustomActiveTab('3');
        }
        if (location.hash.includes('claims')) {
          setcustomActiveTab('4');
        }
      }
      if (lead_data?.lead_type_id === LEAD_TYPE_IDS.LIFE) {

        if (location.hash.includes('applicants')) {
          setcustomActiveTab('1');
        }
        if (location.hash.includes('existing-coverage')) {
          setcustomActiveTab('2');
        }
      }
      if (lead_data?.lead_type_id === LEAD_TYPE_IDS.HEALTH) {
        if (location.hash.includes('applicants')) {
          setcustomActiveTab('1');
        }
        if (location.hash.includes('existing-coverage')) {
          setcustomActiveTab('2');
        }
      }
      if (lead_data?.lead_type_id === 4) { //renters
        if (location.hash.includes('applicants')) {
          setcustomActiveTab('1');
        }
        if (location.hash.includes('existing-coverage')) {
          setcustomActiveTab('2');
        }
      }
      if (BUSINESS_LEAD_TYPES.includes(lead_data?.lead_type_id)) {
        if (location.hash.includes('applicants')) {
          setcustomActiveTab('1');
        }
        if (location.hash.includes('business-entity')) {
          setcustomActiveTab('2');
        }
        if (location.hash.includes('existing-coverage')) {
          setcustomActiveTab('3');
        }
      }
      if (isAutoOrMotorcycle(lead_data?.lead_type_id)) { //auto
        if (location.hash.includes('driver')) {
          setcustomActiveTab('1');
        }
        if (location.hash.includes('vehicles')) {
          setcustomActiveTab('2');
        }
        if (location.hash.includes('existing-coverage')) {
          setcustomActiveTab('3');
        }
        if (location.hash.includes('violations')) {
          setcustomActiveTab('4');
        }
      }
      if (lead_data?.lead_type_id === LEAD_TYPE_IDS.MEDICARE) {
        if (location.hash.includes('applicants')) {
          setcustomActiveTab('1');
        }
        if (location.hash.includes('existing-coverage')) {
          setcustomActiveTab('2');
        }
      }
    }
  }, [location, lead_data]);

  const handleButtonClickOverview = () => {
    setShowTranscription(false);
    setShowSummary(false)
  }

  const handleButtonClickTranscription = () => {
    setShowTranscription(true);
    setShowSummary(false)
  }

  const handleButtonClickSummary = () => {
    setShowTranscription(false);
    setShowSummary(true)
  }

  const handleButtonClislExport = () => {
    const queryParams = {};
    queryParams.lead_id = lead_id;
    queryParams.lead_type_id = lead_data?.lead_type_id;
    queryParams.product_type_id = lead_data?.product_type_id;
    dispatch(getLeadDetailReport({ queryParams }, 'Lead_detail.csv'));
  }

  const onClickOpenNotes = () => {
    if (!isBenepathBrand || !lead_id) return;
    if (isCallDetailsPage && lead_data?.quote_call?.id) {
      // For calls, use quote_call.id as call_id (not lead_data.id which is the lead_id)
      openNotesModal(null, parseInt(lead_id), setLeadNoteModal, lead_data.quote_call.id, call_notes);
    } else {
      // For leads, use lead_id and lead_notes
      openNotesModal(lead_notes, parseInt(lead_id), setLeadNoteModal);
    }
  }

  const onSubmitLeadNoteModal = (newNote) => {
    if (!isBenepathBrand) return;
    if (isCallDetailsPage && lead_data?.quote_call?.id) {
      // For calls, use quote_call.id as call_id (not lead_data.id which is the lead_id)
      dispatch(createCallNotes({
        call_id: lead_data.quote_call.id,
        call_note: {
          text: newNote.text
        }
      }));
    } else {
      // For leads, use lead_id
      dispatch(createLeadNotes({
        lead_id: newNote.lead_id,
        lead_note: {
          text: newNote.text
        }
      }));
    }
  }

  const onCloseLeadNoteModal = () => {
    setLeadNoteModal({
      action: false,
      lead_id: null,
      call_id: null,
      notes: [],
    });
  }
  
  // Use URL pathname first (immediately available), then fall back to product_type_id once data is loaded
  const shouldShowCallDetails = isCallDetailsPage || (!location.pathname.startsWith('/leads/') && lead_data?.product_type_id === 2);

  // Check if we have actual lead data (not just an empty object)
  // This prevents rendering empty components before data is loaded
  const hasLeadData = lead_data && lead_data.id && Object.keys(lead_data).length > 0;
  
  // Show loading state if we're loading OR if we don't have data yet
  const isLoadingOrNoData = loading || !hasLeadData;

  return (
    <div className="page-content" id="page-content-wrapper">
      <MetaTags>
        <title>Details | {AppConfiguration.WEBSITE}</title>
      </MetaTags>
      <Container fluid>
        {isLoadingOrNoData ? '' : shouldShowCallDetails ?
          <CallDetailBreadcrumb
            backOption link={'/calls'}
            handleButtonClickOverview={() => handleButtonClickOverview()}
            handleButtonClickTranscription={() => handleButtonClickTranscription()}
            handleButtonClickSummary={() => handleButtonClickSummary()}
            breadcrumbItem="Call Details"
            title="Calls"
            transcription={showTranscription}
            showSummary={showSummary}
          />
          :
          <Breadcrumbs backOption link={'/leads'} breadcrumbItem="Lead Details" title="Opportunities" />
        }
        {showTranscription ?
          <CallTranscription />
          :
          <Row>
            <Col xl={3}>
              {isLoadingOrNoData ? <LeadDetailLoading /> :
                <LeadSnapshot
                  current_account={current_account}
                  lead_refund_reasons={lead_refund_reasons}
                  lead_data={lead_data}
                  onClickOpenNotes={onClickOpenNotes}
                  lead_notes={lead_notes}
                  call_notes={call_notes}
                  isCallDetailsPage={isCallDetailsPage}
                />}
            </Col >
            {showSummary
              ?
              <Col xl={9}>
                <Card>
                  <CardBody>
                    <CallSummary lead_id={lead_id} />
                  </CardBody>
                </Card>
              </Col>
              :
              <Col xl={9}>
                <Row>
                  <Col>
                    {isLoadingOrNoData ? <LeadNavLinkLoading /> :
                      <div className="d-flex justify-content-between">
                        <ul className="nav sfnav mb-4">
                          <li className="nav-item">
                            <SfNavLink
                              position="1"
                              location={isAutoOrMotorcycle(lead_data?.lead_type_id) ? '#drivers' : '#applicants'}
                              tabName={isAutoOrMotorcycle(lead_data?.lead_type_id) ? 'Drivers' : 'Applicants'}
                              customActiveTab={customActiveTab}
                              setcustomActiveTab={setcustomActiveTab}
                            />
                          </li>

                          <li className="nav-item">
                            <SfNavLink
                              position="2"
                              location={
                                lead_data?.lead_type_id === LEAD_TYPE_IDS.HOME ? '#homes' :
                                  BUSINESS_LEAD_TYPES.includes(lead_data?.lead_type_id) ? "#business-entity" :
                                    isAutoOrMotorcycle(lead_data?.lead_type_id) ? "#vehicles" :
                                      '#existing-coverage'
                              }
                              tabName={
                                lead_data?.lead_type_id === LEAD_TYPE_IDS.HOME ? 'Homes' :
                                  BUSINESS_LEAD_TYPES.includes(lead_data?.lead_type_id) ? "Business Entity" :
                                    isAutoOrMotorcycle(lead_data?.lead_type_id) ? "Vehicles" :
                                      'Existing Coverage'
                              }
                              customActiveTab={customActiveTab}
                              setcustomActiveTab={setcustomActiveTab}
                            />
                          </li>

                          {([LEAD_TYPE_IDS.HOME, ...BUSINESS_LEAD_TYPES].includes(lead_data?.lead_type_id) || isAutoOrMotorcycle(lead_data?.lead_type_id)) &&
                            <li className="nav-item">
                              <SfNavLink
                                position="3"
                                location="#existing-coverage"
                                tabName="Existing Coverage"
                                customActiveTab={customActiveTab}
                                setcustomActiveTab={setcustomActiveTab}
                              />
                            </li>
                          }

                          {lead_data?.lead_type_id === LEAD_TYPE_IDS.HOME &&
                            <li className="nav-item">
                              <SfNavLink
                                position="4"
                                location="#claims"
                                tabName="Claims"
                                customActiveTab={customActiveTab}
                                setcustomActiveTab={setcustomActiveTab}
                              />
                            </li>}

                          {isAutoOrMotorcycle(lead_data?.lead_type_id) &&
                            <li className="nav-item">
                              <SfNavLink
                                position="4"
                                location="#violations"
                                tabName="Violations"
                                customActiveTab={customActiveTab}
                                setcustomActiveTab={setcustomActiveTab}
                              />
                            </li>}
                        </ul>
                        {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS?.SF_FEATURE_FLAG_LEAD_DETAIL_EXPORT) && (
                          <ExportCSVButton
                            type="button" className={`btn btn-outline-sfblue w-md`} style={{ height: '40px' }} onClick={() => handleButtonClislExport()}>
                            <i className="bx bx-import font-size-14 align-middle me-2" />
                            {loading_lead_detail_export ? 'Downloading' : 'Export'}
                          </ExportCSVButton>
                        )}
                      </div>
                    }
                    <TabContent activeTab={customActiveTab}>
                      <TabPane tabId="1">
                        {isLoadingOrNoData ? <LeadSubSectionLoading /> :
                          <LeadDrivers lead_data={lead_data} />}
                      </TabPane>
                      <TabPane tabId="2">
                        {lead_data?.lead_type_id === LEAD_TYPE_IDS.HOME ? isLoadingOrNoData
                          ? <LeadSubSectionLoading />
                          : <LeadHomes lead_data={lead_data} />
                          : null
                        }
                        {[LEAD_TYPE_IDS.LIFE, LEAD_TYPE_IDS.HEALTH, LEAD_TYPE_IDS.MEDICARE, 4].includes(lead_data?.lead_type_id) ? isLoadingOrNoData
                          ? <LeadSubSectionLoading />
                          : <LeadCoverage lead_data={lead_data} />
                          : null
                        }
                        {lead_data?.lead_type_id === LEAD_TYPE_IDS.COMMERCIAL ? isLoadingOrNoData
                          ? <LeadSubSectionLoading />
                          : <LeadBusinessEntity lead_data={lead_data} />
                          : null
                        }
                        {lead_data?.lead_type_id === LEAD_TYPE_IDS.GROUP_HEALTH ? isLoadingOrNoData
                          ? <LeadSubSectionLoading />
                          : <LeadBusinessEntityGroupHealth business_entities={lead_data?.lead_business_entities} />
                          : null
                        }
                        {isAutoOrMotorcycle(lead_data?.lead_type_id) ? isLoadingOrNoData
                          ? <LeadSubSectionLoading />
                          : <LeadVehicles lead_data={lead_data} />
                          : null
                        }

                      </TabPane>
                      <TabPane tabId="3">
                        {isLoadingOrNoData
                          ? <LeadSubSectionLoading />
                          : <LeadCoverage lead_data={lead_data} />
                        }
                      </TabPane>
                      <TabPane tabId="4">
                        {isAutoOrMotorcycle(lead_data?.lead_type_id) ? isLoadingOrNoData
                          ? <LeadSubSectionLoading />
                          : <LeadViolations lead_data={lead_data} />
                          : null
                        }
                        {lead_data?.lead_type_id === LEAD_TYPE_IDS.HOME ? isLoadingOrNoData
                          ? <LeadSubSectionLoading />
                          : <LeadClaims lead_data={lead_data} />
                          : null
                        }
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </Col>}
          </Row >
        }
        {isBenepathBrand && (
          <LeadNoteModal
            modalState={leadNoteModal}
            onSubmitClick={onSubmitLeadNoteModal}
            onCloseClick={onCloseLeadNoteModal}
            textHeading="Lead Notes"
          />
        )}
      </Container >
    </div >
  )
}

export default LeadDetail